<template>
  <CCard class="p-4" v-if="show_email_login || !IS_MZ_BRANDING">
    <CCardBody>
      <CForm @submit.prevent="handleLogin">
        <h1>{{ $t('Login') }}</h1>
        <p class="text-muted">{{ $t('Sign In to your account') }}</p>
        <RaInput
          size="sm"
          :placeholder="$t('Username')"
          autocomplete="username email"
          v-model="login"
          name="login"
          class="mb-2 filter-input"
          required
        >
          <template #prepend-content>
            <i class="fal fa-user" />
          </template>
        </RaInput>
        <RaInput
          size="sm"
          class="filter-input"
          :placeholder="$t('Password')"
          type="password"
          autocomplete="current-password"
          v-model="password"
          name="password"
          required
        >
          <template #prepend-content>
            <i class="fal fa-lock" />
          </template>
        </RaInput>
        <CRow class="mt-2">
          <CCol>
            <CButton
              color="primary"
              class="px-4"
              type="submit"
              data-cy=login-button
            >
              {{ $t('Login') }}
            </CButton>
          </CCol>
          <CCol class="text-right">
            <CButton
              color="link"
              class="px-0"
              :to="{ name: 'Forgot password' }"
              data-cy="forgot-password-link"
            >
              {{ $t('Forgot password?') }}
            </CButton>
          </CCol>
        </CRow>
      </CForm>
    </CCardBody>
  </CCard>

  <CCard
    v-else
    color="primary"
    text-color="white"
    class="text-center py-5"
    body-wrapper
  >
    <CCardBody>
      <h2>{{ $t('Login') }}</h2>
      <p class="text-muted">{{ $t('Login to your Mazars account') }}</p>
      <CCardBody>
        <a :href="mzAuthUri" class="btn btn-lg btn-secondary px-4 text-center">
          <CSpinner v-if="oauthLoading"/>
          <div v-else>
            <img src='/img/logo.png' alt='' style='max-width: 100px'>
            <div>
              {{ $t('Sign in via') }}
              <br>
              Mazars The Gate™
            </div>
          </div>
        </a>
      </CCardBody>
    </CCardBody>
  </CCard>
</template>

<script>
import { API_ENDPOINTS } from '@/constants/common';
import { ActiveUser } from '@/services/user';
import { IS_MZ_BRANDING } from '@/constants/config';
import { AuthService } from '@/services/auth';

export default {
  name: 'Login',
  props: ['show_email_login'],
  data: function () {
    return {
      IS_MZ_BRANDING,
      login: '',
      password: '',
      mzAuthUri: '',
      oauthLoading: false,
    };
  },
  mounted() {
    this.redirectAuthenticated();
    this.tryLoginWithAccessCode();
    if (IS_MZ_BRANDING) {
      this.fetchMzAuthUri();
    }
  },
  methods: {
    redirectAfterLogin() {
      const pathToLoadAfterLogin = localStorage.getItem('pathToLoadAfterLogin');
      localStorage.removeItem('pathToLoadAfterLogin');
      this.$router.replace((!pathToLoadAfterLogin?.includes("login") && pathToLoadAfterLogin) || '/');
    },
    redirectAuthenticated() {
      if (ActiveUser.get()) this.redirectAfterLogin()
    },
    async tryLoginWithAccessCode() {
      const { code, state } = this.$route.query;
      if (code && state) {
        this.oauthLoading = true;
        const { res, data } = await this.$request({
          url: API_ENDPOINTS.mzAuthCallback,
          query: {
            code,
            state,
          },
        });
        if (res.status !== 200) {
          this.oauthLoading = false;
          return alert(this.$t("Login failed"), { color: "danger" });
        }
        await ActiveUser.setToken(data.access_token);
        this.redirectAfterLogin()
      }
    },
    async fetchMzAuthUri() {
      const { data } = await request({
        url: API_ENDPOINTS.mzAuth,
      });
      this.mzAuthUri = data.authorization_url;
    },
    async handleLogin() {
      const { res } = await AuthService.login({
        email: this.login,
        password: this.password,
      });
      if (res.status !== 200) {
        return alert(this.$t('Login failed'), { color: "danger" });
      }
      this.redirectAuthenticated();
    },
  },
};
</script>
